module.exports = __webpack_public_path__ + "img/zk-icon-wallet.b7e15a8d.svg";